import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { SPAuthProvider, useSPAuth } from "./SPAuthContext";
import SPLogin from "./SPLogin";
import SPShell from "./SPShell";
import SPLeads from "./SPLeads";

function SPProtected({ children }) {
  const { actor, loading } = useSPAuth();
  if (loading) {
    return (
      <div className="min-h-screen bg-[#0b0d10] text-zinc-500 flex items-center justify-center text-xs uppercase tracking-[0.3em]" data-testid="sp-loading">
        Loading sales portal…
      </div>
    );
  }
  if (!actor) return <Navigate to="/sales-portal/login" replace />;
  return <SPShell>{children}</SPShell>;
}

export default function SalesPortalApp() {
  return (
    <SPAuthProvider>
      <Routes>
        <Route path="login" element={<SPLogin />} />
        <Route path="leads" element={<SPProtected><SPLeads /></SPProtected>} />
        <Route path="" element={<Navigate to="leads" replace />} />
        <Route path="*" element={<Navigate to="leads" replace />} />
      </Routes>
    </SPAuthProvider>
  );
}
